import { render, staticRenderFns } from "./RoomStatus.vue?vue&type=template&id=827fa0a6&scoped=true&"
import script from "./RoomStatus.vue?vue&type=script&lang=js&"
export * from "./RoomStatus.vue?vue&type=script&lang=js&"
import style0 from "./RoomStatus.vue?vue&type=style&index=0&id=827fa0a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827fa0a6",
  null
  
)

export default component.exports